import { render, staticRenderFns } from "./SpecialApplicationManage.vue?vue&type=template&id=b6842022&scoped=true"
import script from "./SpecialApplicationManage.vue?vue&type=script&lang=js"
export * from "./SpecialApplicationManage.vue?vue&type=script&lang=js"
import style0 from "./SpecialApplicationManage.vue?vue&type=style&index=0&id=b6842022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6842022",
  null
  
)

export default component.exports